export const codeListMapperMessagesEn = {
  // Common
  'codeListMapper.common.notAvailable': '--',

  // Column Headers
  'codeListMapper.column.type': 'Type',
  'codeListMapper.column.id': 'ID',
  'codeListMapper.column.name': 'Name',
  'codeListMapper.column.code': 'Code',
  'codeListMapper.column.vocabulary': 'Vocabulary',
  'codeListMapper.column.standard': 'Standard',
  'codeListMapper.column.domain': 'Domain',
  'codeListMapper.column.class': 'Class',
  'codeListMapper.column.status': 'Status',
  'codeListMapper.column.mappedCount': 'Mapped count',
  'codeListMapper.column.reasoning': 'Reasoning',

  // Status Values
  'codeListMapper.status.mapped': 'Mapped',
  'codeListMapper.status.unmapped': 'Unmapped',
  'codeListMapper.status.notFound': 'Not found',
  'codeListMapper.status.alreadyStandard': 'Already standard',

  // Summary Cards
  'codeListMapper.summary.totalCodes': 'Total Codes',
  'codeListMapper.summary.mapped': 'Mapped',
  'codeListMapper.summary.unmapped': 'Unmapped',
  'codeListMapper.summary.notFound': 'Not found',
  'codeListMapper.summary.alreadyStandard': 'Already standard',

  // Section Headers
  'codeListMapper.section.mappingResults': 'Mapping results',
  'codeListMapper.section.finalConceptList': 'Final concept list',

  // Dialog Titles
  'codeListMapper.title.reviewMappingResults': 'Review mapping results: {fileName}',

  // Footer
  'codeListMapper.footer.reviewInstructions':
    'Review the mappings above. Click "Next" to proceed to confirmation.',

  // Loading States
  'codeListMapper.loading.mappingResults': 'Loading mapping results...',

  // Error States
  'codeListMapper.error.failedToLoad': 'Failed to load mapping results',
  'codeListMapper.error.tryAgain': 'Please try again or contact support if the issue persists.',
};
